import React, { useState, useEffect } from "react";
import { useModal } from "../../../hooks/useModal";
import useStyles from "../styles";
import axios from "axios"
import config from "../../../config"

// components
import InputComponent from "../../partner/components/inputComponent";
import InputSelect from "../../partner/components/inputSelect";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import InputDecimal from "../../partner/components/inputDecimal";
import InputDisableAge from "./inputDisableAge";
import SwitchToUseGym from "./switch";
import { TextField } from "@material-ui/core";
import Modal from "../../modals/Modal";
//import ModalCamera from "../../modals/ModalCamera";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { RefreshRounded } from "@material-ui/icons";
import SimpleImageInput from "./simpleImageInput";

export default function AddUser() {
  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    address: /^[a-zA-Z0-9#, ]{4,500}$/, // Address
  }

  const classes = useStyles();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [name, setName] = useState({ text: '', valid: null });
  const [lastName, setLastName] = useState({ text: '', valid: null });
  const [birthdayDate, setBirthdayDate] = useState('');
  const [age, setAge] = useState('Edad');
  const [address, setAddress] = useState({ text: '', valid: null });
  const [image, setImage] = useState(null);
  const [email, setEmail] = useState({ text: '', valid: null });
  const [password, setPassword] = useState({ text: '', valid: null });
  const [phone, setPhone] = useState({ text: '', valid: null });
  const [rightToUseGym, setRightToUseGym] = useState(false);
  const [gender, setGender] = useState({ text: '', valid: null });
  const [fingerPrint, setFingerPrint] = useState({ text: '', valid: null });
  const [job, setJob] = useState({ text: '', valid: null });
  const [userType, setUserType] = useState({ text: '', valid: null });
  const [checkIn, setCheckIn] = useState('00:00');
  const [checkOut, setCheckOut] = useState('00:00');
  const [salary, setSalary] = useState({ text: '', valid: null });
  const [paymentMethod, setPaymentMethod] = useState({ text: '', valid: null });
  const [paymentPeriod, setPaymentPeriod] = useState({ text: '', valid: null });
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [allFingerPrints, setAllFingerPrints] = useState([]);
  const [principalImage, setPrincipalImage] = useState(null);

  const [allGenders, setAllGenders] = useState([]);
  const [allUserType, setAllUserType] = useState([]);
  const [allJobs, setAllJob] = useState([]);
  const [allPaymentMethod, setAllPaymentMethod] = useState([]);
  const [allPaymentPeriod, setAllPaymentPeriod] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  //const [isOpenModalCamera, openModalCamera, closeModalCamera] = useModal(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchGenders = async () => {
    fetch(baseUrl + "genders",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error == null) {
          setAllGenders(data);
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  const fetchUserType = async () => {
    if (!showModal) {
      fetch(baseUrl + "userType",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllUserType(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchJob = async () => {
    if (!showModal) {
      fetch(baseUrl + "job",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllJob(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchPaymentMethod = async () => {
    if (!showModal) {
      fetch(baseUrl + "paymentMethod",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllPaymentMethod(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchPaymentPeriod = async () => {
    if (!showModal) {
      fetch(baseUrl + "paymentPeriod",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error == null) {
            setAllPaymentPeriod(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fechFingerPrints = async () => {
    if (!showModal) {
      fetch(baseUrl + "getTemplates",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setAllFingerPrints(data);
          }
        })
        .catch(error => null);
    }
  }

  useEffect(() => {
    fetchGenders();
    fetchUserType();
    fetchJob();
    fetchPaymentMethod();
    fetchPaymentPeriod();
    fechFingerPrints();
  }, []);

  const handleCheckInChange = (event) => {
    setCheckIn(event.target.value);
  };

  const handleCheckOutChange = (event) => {
    setCheckOut(event.target.value);
  };

  const onChangeDatePicker = (e) => {
    setBirthdayDate(e.target.value);

    var today = new Date();
    var birthDate = new Date(e.target.value);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    setAge(age);
  }

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    if (name.valid === 'true' && lastName.valid === 'true' && phone.valid === 'true'
      && job.valid === 'true' && userType.valid === 'true'
      && salary.valid === 'true' && paymentMethod.valid === 'true' && paymentPeriod.valid === 'true') {
      const formData = new FormData();

      if (principalImage != null) formData.append("file", principalImage);
      formData.append("name", name.text);
      formData.append("lastName", lastName.text);
      formData.append("birthdayDate", birthdayDate);
      formData.append("age", age == 'Edad' ? 0 : age);
      formData.append("password", password.text);
      formData.append("address", address.text);
      formData.append("email", email.text);
      formData.append("phone", phone.text);
      formData.append("rightToUseGym", rightToUseGym == true ? 1 : 0);
      formData.append("gender", gender.text);
      formData.append("fingerPrint", fingerPrint.text);
      formData.append("job", job.text);
      formData.append("userType", userType.text);
      formData.append("checkIn", checkIn);
      formData.append("checkOut", checkOut);
      formData.append("salary", salary.text);
      formData.append("paymentMethod", paymentMethod.text);
      formData.append("paymentPeriod", paymentPeriod.text);

      axios({
        method: "post",
        url: baseUrl + "createUser",
        data: formData,
        headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
      })
        .then(function (response) {
          if (response.data.message == "Ok") {
            setName({ text: '', valid: null });
            setLastName({ text: '', valid: null });
            setBirthdayDate('');
            setAge('Edad');
            setAddress({ text: '', valid: null });
            setImage(null);
            setEmail({ text: '', valid: null });
            setPassword({ text: '', valid: null });
            setPhone({ text: '', valid: null });
            setRightToUseGym(false);
            setGender({ text: '', valid: null });
            setFingerPrint({ text: '', valid: null });
            setJob({ text: '', valid: null });
            setUserType({ text: '', valid: null });
            setCheckIn('00:00');
            setCheckOut('00:00');
            setSalary({ text: '', valid: null });
            setPaymentMethod({ text: '', valid: null });
            setPaymentPeriod({ text: '', valid: null });
            setAutocompleteKey(0);
            setPrincipalImage(null);

            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          } else {
            if (response.data.message == "Access is denied") {
              setShowModal(true);
            }
          }
        })
        .catch(function (response) { });

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }

  const onTagsChange = (event, values) => {
    if (values != null) {
      setFingerPrint({ text: values.template, valid: "true" });
    } else {
      setFingerPrint({ text: '', valid: "false" });
    }
  }

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}
      <PageTitle title="Usuarios" />

      <div className={classes.divCard} >
        <div className={classes.divTitle}>
          <label className={classes.titleStyle}>Agregar usuario</label>
        </div>

        <div className={classes.divColumn} >
          <InputComponent
            text={name}
            setPartnerCode={setName}
            type="text"
            label="Nombres"
            name="name"
            regularExpression={expressions.nombre}
            placeholder="Nombre"
            isRequired={true}
          />

          <InputComponent
            text={lastName}
            setPartnerCode={setLastName}
            type="text"
            label="Apellidos"
            name="lastName"
            regularExpression={expressions.nombre}
            placeholder="Apellidos"
            isRequired={true}
          />

          <div className={classes.divDate}>
            <label className={classes.labelDate} >Fecha de nacimiento</label>
            <TextField
              type="date"
              defaultValue="2003-10-22"
              className={classes.inputDate}
              onChange={onChangeDatePicker}
              style={{ width: '85%' }}
              inputStyle={{ width: '85%' }}
            />
          </div>

          <InputDisableAge
            value={age}
            type="text"
            label="Edad"
            name="age"
            placeholder="18 años"
          />

          <SimpleImageInput
            text={principalImage}
            setValue={setPrincipalImage}
            label={"Foto del usuario"}
          />

          <InputSelect
            text={gender}
            setValue={setGender}
            label={"Género"}
            options={allGenders}
          />

          <InputComponent
            text={phone}
            setPartnerCode={setPhone}
            type="text"
            label="Teléfono"
            name="phone"
            regularExpression={expressions.numbers}
            placeholder="6688888888"
            isRequired={true}
          />

          <InputComponent
            text={email}
            setPartnerCode={setEmail}
            type="text"
            label="Correo electrónico"
            name="email"
            regularExpression={expressions.email}
            placeholder="correo@ejemplo.com"
            isRequired={false}
          />

          <InputComponent
            text={password}
            setPartnerCode={setPassword}
            type="password"
            label="Contraseña"
            name="password"
            regularExpression={expressions.password}
            placeholder="contraseña"
            isRequired={false}
          />

          <InputComponent
            text={address}
            setPartnerCode={setAddress}
            type="text"
            label="Dirección"
            name="address"
            regularExpression={expressions.address}
            placeholder="Calle primera, 1234, Centro"
          />

          {/*<div>
            <label className={classes.label} >Foto del usuario</label>
            <button
              className={classes.enableButtonFinger}
              onClick={openModalCamera}>
              Tomar foto
            </button>
            <ModalCamera
              isOpen={isOpenModalCamera}
              closeModal={closeModalCamera}
              setPhoto={setImage}
            />
          </div>*/}

          <div>
            <div className={classes.divLabel}>
              <label className={classes.label} >Huella digital</label>
              {/*{isRequired ? (
                <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
              ) : (
                <></>
              )}*/}
            </div>

            <div className={classes.divHeader} >
              <div className={classes.searchDivFullWidthWithoutShadow} >
                <Autocomplete
                  key={autocompleteKey}
                  options={allFingerPrints}
                  getOptionLabel={option => option.code}
                  onChange={onTagsChange}
                  className={classes.inputSearchFinger}
                  openText={"Abrir"}
                  closeText={"Cerrar"}
                  clearText={"Limpiar"}
                  noOptionsText={"Sin resultados"}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder={"Buscar huella digital"}
                      fullWidth
                    />
                  )}
                />

                <div className={classes.divActionButton}>
                  <RefreshRounded className={classes.iconAcctionInventory}
                    onClick={fechFingerPrints}
                  />
                </div>
              </div>
            </div>
          </div>

          <InputSelect
            text={userType}
            setValue={setUserType}
            label={"Tipo de usuario"}
            options={allUserType}
            isRequired={true}
          />

          <InputSelect
            text={job}
            setValue={setJob}
            label={"Puesto"}
            options={allJobs}
            isRequired={true}
          />

          <div className={classes.row}>
            <div className={classes.divDate}>
              <label className={classes.labelDate} >Hora de entrada</label>
              <TextField
                id="time"
                type="time"
                defaultValue="00:00"
                className={classes.textFieldTime}
                InputLabelProps={{
                  shrink: true,
                }}
                value={checkIn}
                onChange={handleCheckInChange}
              />
            </div>

            <div className={classes.divDate}>
              <label className={classes.labelDate} >Hora de salida</label>
              <TextField
                id="time"
                type="time"
                defaultValue="00:00"
                className={classes.textFieldTime}
                InputLabelProps={{
                  shrink: true,
                }}
                value={checkOut}
                onChange={handleCheckOutChange}
              />
            </div>
          </div>

          <InputDecimal
            text={salary}
            setPartnerCode={setSalary}
            type="text"
            label="Sueldo"
            name="salary"
            placeholder="0.00"
            isRequired={true}
          />

          <InputSelect
            text={paymentMethod}
            setValue={setPaymentMethod}
            label={"Método de pago"}
            options={allPaymentMethod}
            isRequired={true}
          />

          <InputSelect
            text={paymentPeriod}
            setValue={setPaymentPeriod}
            label={"Periodo de pago"}
            options={allPaymentPeriod}
            isRequired={true}
          />

          <SwitchToUseGym
            value={rightToUseGym}
            setValue={setRightToUseGym}
            label="Permiso para usar el gimnasio"
          />
        </div>

        <div className={classes.divButton}>
          {isLoading ? (
            <div className={classes.loginLoader} >
              <CircularProgress size={26} />
            </div>
          ) : (
            <button
              className={name.valid === 'true' && lastName.valid === 'true'
                && phone.valid === 'true' && job.valid === 'true' && userType.valid === 'true'
                && salary.valid === 'true' && paymentMethod.valid === 'true' && paymentPeriod.valid === 'true' ?
                classes.enableButton : classes.disableButton}
              disabled={!(name.valid === 'true' && lastName.valid === 'true'
                && phone.valid === 'true' && job.valid === 'true' && userType.valid === 'true'
                && salary.valid === 'true' && paymentMethod.valid === 'true' && paymentPeriod.valid === 'true')}
              onClick={onSubmit}
            >Agregar</button>
          )}
        </div>
      </div>
    </div>
  );
}
